import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { addDays } from "date-fns";
import { Info } from "lucide-react";
import { sessionSelector } from "@/features/sessionSlice";
import { useAppSelector } from "@/hooks";
import { parsedDate } from "@/lib/dates";
import DemoExpiredOverlay from "./DemoExpiredOverlay";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { Button } from "./ui/button";
export default function DemoCountdown({ vertical = false }) {
    const { customer } = useAppSelector(sessionSelector);
    const [showOverlay, setShowOverlay] = useState(false);
    if (!customer?.demoStartedAt || customer.demoExpired) {
        return null;
    }
    const demoEnd = addDays(parsedDate(customer.demoStartedAt), 7);
    const now = new Date();
    const remaining = demoEnd.getTime() - now.getTime();
    if (remaining <= 0) {
        return null;
    }
    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let text;
    if (days > 0) {
        text = `Dein Demo-Zeitraum endet in ${days} ${days === 1 ? "Tag" : "Tagen"} und ${hours} ${hours === 1 ? "Stunde" : "Stunden"}.`;
    }
    else {
        text = `Dein Demo-Zeitraum endet in ${hours} ${hours === 1 ? "Stunde" : "Stunden"}.`;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Alert, { children: [_jsxs(AlertTitle, { children: [_jsx(Info, { className: "inline h-4 w-4 mr-1 align-text-bottom" }), "Demo"] }), _jsxs(AlertDescription, { className: vertical ? "mt-2 space-y-2" : "flex items-center justify-between", children: [_jsx("span", { children: text }), _jsx(Button, { variant: "outline", size: "sm", onClick: () => setShowOverlay(true), children: "Jetzt Plan buchen" })] })] }), _jsx(DemoExpiredOverlay, { open: showOverlay, onOpenChange: setShowOverlay })] }));
}
